<template>
  <div class="personal-notification__box">
    <a
      class="personal-notification__box__link"
      :href="linkUrl"
      @click="onClickLink"
    >
      <div class="personal-notification__box__icon-area">
        <span v-if="unread" class="personal-notification__box__unread-mark" />
        <img
          v-lazy="iconUrl"
          :class="`personal-notification__box__image--${iconStyle}`"
          alt="icon"
        />
      </div>
      <div class="personal-notification__box__text">
        <p class="personal-notification__box__date">
          {{ startedAt }}
        </p>
        <p class="personal-notification__box__title">
          {{ message }}
        </p>
      </div>
    </a>
    <div class="personal-notification__box__right-button-area">
      <button
        class="personal-notification__box__delete-button"
        @click="onClickDeleteButton"
      >
        <TrashOutline class="personal-notification__box__delete-button--icon" />
      </button>
    </div>
  </div>
</template>
<script>
import TrashOutline from '../../../atoms/svg_icons/TrashOutline.vue'

export default {
  components: {
    TrashOutline
  },
  props: {
    personalNotificationId: {
      type: Number,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    startedAt: {
      type: String,
      required: true
    },
    iconUrl: {
      type: String,
      required: true
    },
    iconStyle: {
      type: String,
      required: true
    },
    linkUrl: {
      type: String,
      required: true
    },
    unread: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    onClickDeleteButton() {
      this.$emit('click-delete-button', this.personalNotificationId)
    },
    onClickLink() {
      this.$emit('click-link', this.personalNotificationId)
    }
  }
}
</script>
<style lang="scss" scoped>
.personal-notification {
  &__box {
    display: flex;
    height: 54px;
    align-items: center;

    &__link {
      display: flex;
      flex: 1;
      align-items: center;
    }

    &__icon-area {
      width: 50px;
      display: flex;
      justify-content: flex-end;
      margin: auto 16px auto 0;
    }

    &__unread-mark {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $danger;
    }

    &__image {
      &--circle {
        max-width: 100%;
        width: 44px;
        height: 44px;
        border-radius: 50%;
      }

      &--square {
        margin: 6px 4px 0 2px;
        max-width: 100%;
        width: 38px;
        height: 38px;
      }
    }

    &__text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
      flex: 1;
    }

    &__date {
      padding-bottom: 4px;
      font-size: 1rem;
      line-height: 1.6;
      color: $gray-1;
    }

    &__title {
      font-size: 1.2rem;
      line-height: 1.6;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      color: $black;
      white-space: pre-wrap;
    }

    &__right-button-area {
      height: 24px;
      margin-left: 16px;
    }

    &__delete-button {
      cursor: pointer;

      &--icon {
        fill: $gray-1;
      }
    }
  }
}
</style>
